import axios from "axios";
import { API_END_POINT } from "../../../../config";
import { startSpinner, stopSpinner } from "../../../shared-components/custom-spinner/custom-spinner-store/spinner-actions";
import { TestAction, fetchTransactionListByID, getSurveyDefinition, updateSurveyWithTranslations } from "./design-actions-creators";
import { loadToaster } from "../../../shared-components/toaster/toaster-actions-creators";
import { localSurveyDefinition } from "../Helpers/QuestionsModel";
import { TRANSLATION_LIST } from "./design-store-constants";
import { fetchProjectCode } from "../../ProjectList/home-store/home-actions-creators";

export const fetchTestCall = () => {
    return (dispatch) => {
        try {
            // dispatch(startSpinner());
            dispatch(TestAction("ravikrishnapunnam@gmail.com"));

        } catch (err) {

        }

    };
};
export const createOrUpdateSurveyDefinition = (postObject) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await axios.post(`${API_END_POINT.BASE_URL}/api/Survey/PostSurveyDefinition`, postObject);
            dispatch(loadToaster({ type: 'success', title: 'Saved Successfully!!', msg: '' }))
            let getDetails = JSON.parse(postObject.survey_definition);
            if (Object.keys(getDetails).length !== 0) {
                getDetails.pages = getDetails.pages.map((page) => {
                    const updatedElements = page.elements.map((element) => {
                        if (element.selectedType.questionType === 'selectList'
                            || element.selectedType.questionType === 'ranking'
                        ) {
                            const updatedChoices = element.choices.map((choice) => {
                                return choice.split(',').join(',\n');
                            });
                            return {
                                ...element,
                                choices: updatedChoices,
                            };
                        }
                        return element;
                    });
                    return {
                        ...page,
                        elements: updatedElements,
                    };
                });;
                dispatch(getSurveyDefinition(getDetails));

            }
            dispatch(stopSpinner());

        } catch (err) {
            console.error(err);
            dispatch(stopSpinner());
            throw err; // Throw the error to the caller
        }
    };
};

export const fetchSurveyDefintionListByID = (postObject) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await axios.get(`${API_END_POINT.BASE_URL}/api/Survey/GetSurveyDefinitionByID/${postObject}`);
            let getDetails = response.data.data;
            // console.log(getDetails,"api call")
               dispatch(fetchProjectCode(getDetails.surveycode));
            
            if (getDetails && Object.keys(getDetails).length !== 0 && getDetails.pages?.length > 0) {
                // console.log(getDetails.pages, "pages")
                // Safely handle pages array
                getDetails.pages = (getDetails.pages || []).map((page) => {
                    // Safely handle elements array
                    const elements = page.elements || [];
                    const updatedElements = elements.map((element) => {
                        if ((element.selectedType?.questionType === 'selectList' || 
                             element.selectedType?.questionType === 'ranking') && 
                            Array.isArray(element.choices)) {
                            const updatedChoices = element.choices.map((choice) => {
                                return typeof choice === 'string' ? choice.split(',').join(',\n') : choice;
                            });
                            return {
                                ...element,
                                choices: updatedChoices,
                            };
                        }
                        return element;
                    });
                    return {
                        ...page,
                        elements: updatedElements,
                    };
                });
                
                dispatch(getSurveyDefinition(getDetails));
            } else {
                   const fallbackSurvey = {
                    ...localSurveyDefinition,
                    surveyid: getDetails?.surveyid,
                    surveyname: getDetails?.surveyname,
                    surveycode: getDetails?.surveycode,
                    translations: getDetails?.translations || { languages: ["English"] },
                };
                dispatch(getSurveyDefinition(fallbackSurvey));
            }
            dispatch(stopSpinner());

        } catch (err) {
            console.error(err);
            dispatch(stopSpinner());
            throw err;
        }
    };
};

export const SaveSurveyTranslation = (postObject) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await axios.post(
                `${API_END_POINT.BASE_URL}/api/Survey/PostSurveyTranslation`, 
                postObject
            );
            
            dispatch(loadToaster({ 
                type: 'success', 
                title: 'Translation Saved Successfully!!', 
                msg: '' 
            }));
            
            // After saving, update the store with new translations
            if (response.data.data) {
                dispatch(fetchTransactionListByID(response.data.data));
                dispatch(updateSurveyWithTranslations(response.data.data));
            }
            
            dispatch(stopSpinner());
            return response.data.data;

        } catch (err) {
            console.error(err);
            dispatch(stopSpinner());
            throw err;
        }
    };
};

export const TransactionListByID = (postObject) => {
    return async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await axios.get(
                `${API_END_POINT.BASE_URL}/api/Survey/GetSurveyTranslationById/${postObject}`
            );
            console.log(response.data.data, "response data");
            // Dispatch both the raw list and merged data
            if (response.data.data) {
                dispatch(fetchTransactionListByID(response.data.data || []));
                
                // Also update the survey with these translations
                dispatch(updateSurveyWithTranslations(response.data.data));
            }
            
            dispatch(stopSpinner());
            return response.data.data || {};

        } catch (err) {
            console.error(err);
            dispatch(stopSpinner());
            throw err;
        }
    };
};